window.onscroll = function() {HeaderSticky()};
var header = document.getElementById("sticky");
var sticky = header.offsetTop;

function HeaderSticky() {
  if (window.pageYOffset > sticky) {
    header.classList.add("sticky");
    document.getElementById("logotype").src="https://cdn.shopify.com/s/files/1/0285/7363/0523/files/logo-70.svg?1815";
  } else {
    header.classList.remove("sticky");
    document.getElementById("logotype").src="https://cdn.shopify.com/s/files/1/0285/7363/0523/files/saperavi-logo.svg?152";
  }
}

var menu = document.getElementById("toggle");
var logo = document.getElementById("logotype");
var search = document.getElementById("search");
var menuClose = document.querySelector("toggle-container");

menu.onclick = function () {
	if (document.getElementById('toggle').checked) {
            logo.style.opacity = "0";
  			search.style.opacity = "0";
        } else {
            logo.style.opacity = "1";
  			search.style.opacity = "1";
        }
};



( function( document ) {
  var delay = 150;
  
  function animate( elements ) {
    elements.forEach( function( element, index ) {
      var length = element.getTotalLength();
    
      // Set up the starting positions
      element.style.strokeDasharray = length + ' ' + length;
      element.style.strokeDashoffset = length;
      // Trigger a layout so styles are calculated & the browser
      // picks up the starting position before animating
      element.getBoundingClientRect();
      
      setTimeout( function() {
        element.style.strokeDashoffset = '0';
        element.classList.add( 'fillIt' );
      }, delay * index );
    } );
  }
  
  var logoLines = Array.prototype.slice.call( document.getElementsByClassName( 'logo' ), 0);
  var letters = Array.prototype.slice.call( document.getElementsByClassName( 'letter' ), 0);
  var usa = Array.prototype.slice.call( document.getElementsByClassName( 'usa' ), 0);
  var glass = Array.prototype.slice.call( document.getElementsByClassName( 'glass' ), 0);
  animate( glass );
  animate( letters );
  animate( usa );
  
  animate( logoLines );
  
  
} )( document );





// //empty chart modal
// var modal = document.querySelector('.chartModal');
// var btn = document.querySelector('.chart');
// btn.onclick = function () {
//     modal.style.display = "block";
// };
// window.onclick = function (event) {
//     if (event.target === modal) {
//         modal.style.display = "none";
//     }
// };

//full chart sidebar
// var popupChart = document.querySelector('.your-chart_sidebar');
// var spanClose = document.querySelector('.sidebar-close');
// btn.onclick = function () {
//     popupChart.style.right = "0";
// };
// spanClose.onclick = function () {
//     popupChart.style.right = "-110%";
// };
// window.onclick = function (event) {
//     if (event.target === popupChart) {
//         popupChart.style.right = "0";
//     }
// };

//subscribe modal


// //send modal
// var send = document.querySelector('.send-overlay');
// var btnSend = document.querySelector('.send');
// var sendClose = document.querySelector('.send-close');
// btnSend.onclick = function () {
//     send.style.display = "block";
// };

// sendClose.onclick = function () {
//     send.style.display = "none";
// };
// window.onclick = function (event) {
//     if (event.target === send) {
//         send.style.display = "none";
//     }
// };

